export default __webpack_public_path__ + "static/media/ImportChargeback.de97f1d5.csv";